import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../app-services/auth.service';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              private authService: AuthService) { }
  resetString: string;
  private sub: any;

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
       this.resetString = params['uniqueresetstring']; // (+) converts string 'id' to a number
    });
  }

  public onSubmit(value: any) {

    value.token = this.resetString;
    this.authService.resetPassword(value);
  }


  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/resetpassword/resetpassword.component.ts